import roundToTwoDecimals from './roundToTwoDecimals';

/**
 * Formats pounds to a human readable string with abbreviated unit.
 * e.g: 2.220092 -> 2.22 lb.
 * @param {Number} pounds
 */
const formatPounds = pounds => `${roundToTwoDecimals(pounds)} lb.`;

export default formatPounds;
